<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-07-16 09:02:39
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-08-10 15:44:17
 * @FilePath: \vue-app-console\src\views\SystemMTG\Role.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >    
            <a-select 
                v-if="userInfo.tenant_id == 1"
                class="query_field"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')"
                :options="searchTenantOptions"
                @change="handleSelectChange('tenant')"
            ></a-select>

            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('create')">
                <img src="@/assets/image/addAccount.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('role.createRole') }}
            </a-button>
        </div>

        <!-- <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('create')">
                <img src="@/assets/image/addAccount.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('role.createRole') }}
            </a-button>
        </div> -->

        <div>
            <Table
                class="table"
                :table="table"
                @handleChangePagination="handleChangePagination"
            >
                <!-- <template v-slot:customCol="{props}"></template> -->

                <!-- 父表格操作按钮 -->
                <template v-slot:tableAction="{props}">
                    <template v-if="props.column.key === 'action'">
                        <a-button type="primary" size="small" style="margin-right:10px" :disabled="props.record.category == -1 || props.record.category == 0 || props.record.role_name == 'sys:tenantDefault' ||  props.record.role_name == 'sys:default' || props.record.role_name == 'sys:admin' || props.record.role_name == 'sys:test'" @click="handle('edit',props.record)">
                            {{ $t('role.edit') }}
                        </a-button>
                        <a-button size="small" style="margin-right:10px" :disabled="props.record.category == -1 || props.record.category == 0 || props.record.role_name == 'sys:tenantDefault' || props.record.role_name == 'sys:default' || props.record.role_name == 'sys:admin' || props.record.role_name == 'sys:test' || props.record.role_name == 'super admin'" @click="handle('delete',props.record)">
                            {{ $t('role.delete') }}
                        </a-button>
                        <a-button size="small" @click="handle('bindMenu',props.record)">
                            {{ $t('role.bindMenu') }}
                        </a-button>
                    </template>
                </template>
            </Table>
        </div>

        <a-modal 
            v-model:open="visible"
            :closable="false"
            :width="550"
            centered
            :maskClosable="false"
            :okText="t('base.confirm')"
            :cancelText="t('base.cancel')"
            @ok="addRole"
            @cancel="visible = false"
        >
            <div class="modal_title">{{ modal_title }}</div>

            <div class="form">
                <div class="form_item">
                    <div class="form_item_label">{{ $t('role.roleName') }} <span class="required">*</span> </div>
                    <div>
                        <a-input 
                            v-model:value="formData.role_name"
                            :maxlength="45"
                            allowClear
                            @change="changeInput"
                        />
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ $t('role.roleDesc') }}</div>
                    <div>
                        <a-input 
                            v-model:value="formData.role_desc"
                            :maxlength="70"
                            allowClear
                            @change="changeInput"
                        />
                    </div>
                </div>
                <div class="form_item" v-if="userInfo.tenant_id == 1">
                    <div class="form_item_label">{{ $t('role.tenant') }} <span class="required">*</span> </div>
                    <div>
                        <a-select 
                            v-model:value="formData.tenant_id" 
                            style="width: 100%" 
                            :options="tenantOptions"
                            :disabled="tenant_disabled"
                            @change="handleChangeTenant"
                        ></a-select>
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ $t('role.roleParent') }} <span class="required">*</span> </div>
                    <div>
                        <a-tree-select
                            v-model:value="formData.role_parent"
                            show-search
                            style="width: 100%"
                            :disabled="userInfo.tenant_id == 1 && formData.tenant_id === ''"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            allow-clear
                            :tree-default-expand-all="true"
                            :tree-data="selectTreeData"
                            tree-node-filter-prop="label"
                            @change="handleChangeRoleParent"
                        >
                            <template #title="{ value: val, label }">
                                <b v-if="val === 'parent 1-1'" style="color: #08c"></b>
                                <template v-else>{{ label }}</template>
                            </template>
                        </a-tree-select>
                    </div>
                </div>
                <div class="form_item" style="margin:20px 0 30px;">
                    <div>
                        <a-checkbox v-model:checked="formData.role_issued">{{ $t('role.authTip') }}</a-checkbox>
                    </div>
                </div>
            </div>
        </a-modal>

        <a-modal 
            v-model:open="bindMenuVisible"
            :closable="true"
            :width="850"
            centered
            :maskClosable="false"
            :okText="t('base.confirm')"
            :cancelText="t('base.cancel')"
            @ok="addRoleMenu"
            @cancel="bindMenuVisible = false"
        >
            <div class="modal_title">{{ modal_title }}</div>
            
            <a-tabs v-model:activeKey="activeKey" @change="handleChangeTab">
                <a-tab-pane key="0">
                    <template #tab>
                        <span><appstore-outlined />{{ $t('menuMgt.page') }}</span>
                    </template>
                </a-tab-pane>
                <!-- <a-tab-pane key="1">
                    <template #tab>
                        <span><playCircle-outlined />{{ $t('menuMgt.button') }}</span>
                    </template>
                </a-tab-pane>
                <a-tab-pane key="2">
                    <template #tab>
                        <span><codeSandbox-outlined />{{ $t('menuMgt.businessFun') }}</span>
                    </template>
                </a-tab-pane> -->
                <a-tab-pane key="3" v-if="userInfo.tenant_id == 1 && category.length > 0">
                    <template #tab>
                        <span><api-outlined />{{ $t('menuMgt.interface') }}</span>
                    </template>
                </a-tab-pane>
            </a-tabs>

            <!-- 页面、功能点 -->
            <div class="menu_tree" v-show="activeKey === '0'">
                <a-tree
                    v-if="treeData.length > 0"
                    v-model:expandedKeys="expandedKeys"
                    v-model:selectedKeys="selectedKeys"
                    v-model:checkedKeys="checkedKeys"
                    checkable
                    :tree-data="treeData"
                    @check="handleMenuTreeCheck"
                ></a-tree>
                <a-empty v-else />
            </div>

            <!-- 接口 -->
            <div class="menu_tree" v-show="activeKey === '3'">
                <div style="margin-bottom: 10px;">
                    <a-select 
                        v-model:value="menu_method" 
                        allowClear
                        :options="methodOptions" 
                        :placeholder="t('base.method')" 
                        style="width: 200px; margin-right: 10px"
                        @change="handleSearchByURLMethod"
                    ></a-select>
                    <a-input
                        v-model:value="menu_url" 
                        allowClear
                        :placeholder="t('base.url')" 
                        style="width: 200px; margin-right: 10px" 
                        @change="handleSearchByURLMethod"
                    />
                    <a-input
                        v-model:value="menu_name" 
                        allowClear
                        :placeholder="t('base.interfaceName')" 
                        style="width: 200px; margin-right: 10px" 
                        @change="handleSearchByURLMethod"
                    />
                    <a-button type="primary" @click="handleSearchByURLMethod">{{ $t('base.search') }}</a-button>
                </div>

                <a-checkbox v-model:checked="checkedAll" style="margin: 5px 0 10px;" @change="handleCheckAll">{{ $t('base.checkAll') }}</a-checkbox>
                <a-tree
                    class="interface_tree"
                    v-model:checkedKeys="interfaceCheckedKeys"
                    checkable
                    :tree-data="interfaceTreeData"
                    @check="handleInterfaceTreeCheck"
                ></a-tree>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, computed, createVNode, nextTick, watch} from "vue";
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { getLastWeekDate } from '@/utils/global';
    import { RoleApi } from '@/api/RoleApi.js';
    import { MenuApi } from '@/api/MenuApi.js';



    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible = ref(false)
    const bindMenuVisible = ref(false)
    const activeKey = ref('0')
    const rowData = ref(null)
    const operate_type = ref('create')
    const modal_title = ref(t('role.createRole'))

    const menu_ids = ref([])
    const treeData = ref([])
    const expandedKeys = ref([])
    const selectedKeys = ref([])
    const checkedKeys = ref([])
    const checkedAll = ref(false)

    const interface_menu_ids = ref([])
    const interfaceTreeData = ref([])
    const interfaceCheckedKeys = ref([])

    const tenant_disabled = ref(false)
    const category = ref([])

    const menu_name = ref('')
    const menu_url = ref('')
    const menu_method = ref(null)
    const methodOptions = ref([
        {
            label:'GET',
            value: 'GET',
        },
        {
            label: 'POST',
            value: 'POST',
        },
        {
            label: 'PUT',
            value: 'PUT',
        },
        {
            label: 'DELETE',
            value: 'DELETE',
        },
        {
            label: 'PATCH',
            value: 'PATCH',
        },
    ])

    const selectTreeData = ref([])

    const headerData = ref({
        menu:'menu.Role',
        menu_desc: 'menu.subRoleMTG',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const searchForm = reactive({
        tenant_id: null,
    })
    const tenantOptions = ref([])
    const searchTenantOptions = ref([])

    const formData = reactive({
        role_name:'',
        role_desc:'',
        tenant_id:'',
    })

    const table = ref({
        data: [],
        columns: [
            {
                title: t('role.roleName'),
                dataIndex: 'role_name_text',
                key: 'role_name_text',
                width: 180,
            },
            {
                title: t('role.roleDesc'),
                dataIndex: 'role_desc',
                key: 'role_desc',
                width: 260,
            },
            {
                title: t('role.roleIssued'),
                dataIndex: 'role_issued_text',
                key: 'role_issued_text',
                width: 170,
                filters: [
                    {
                        text: t('base.allow'),
                        value: t('base.allow'),
                    },
                    {
                        text: t('base.notAllow'),
                        value: t('base.notAllow'),
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.role_issued_text.indexOf(value) === 0,
            },
            {
                title: t('role.roleCategory'),
                dataIndex: 'category_text',
                key: 'category_text',
                width: 90,
                filters: [
                    {
                        text: t('role.systemDefault'),
                        value: t('role.systemDefault'),
                    },
                    {
                        text: t('role.selfCreated'),
                        value: t('role.selfCreated'),
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.category_text.indexOf(value) === 0,
            },
            {
                title: t('role.roleID'),
                dataIndex: 'id',
                key: 'id',
                width: 70,
            },
            {
                title: t('role.parentID'),
                dataIndex: 'role_parent',
                key: 'role_parent',
                width: 70,
            },
            ...(userInfo.value.tenant_id == 1 ? [{
                title: t('role.tenant'),
                dataIndex: 'tenant_name',
                key: 'tenant_name',
                width: 90,
                // filters: [
                //     {
                //         text: 'GOBAO',
                //         value: 'GOBAO',
                //     },
                //     {
                //         text: 'HEPHA',
                //         value: 'HEPHA',
                //     },
                //     {
                //         text: 'Corest',
                //         value: 'Corest',
                //     },
                //     {
                //         text: 'Birk',
                //         value: 'Birk',
                //     },
                // ],
                // filterMultiple: false,
                // onFilter: (value, record) => record.tenant_name.indexOf(value) === 0,
            }] : []),
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 150,
                resizable: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1700,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:20,
                showSizeChanger: true,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })



    const handle = (type , row)=>{
        switch(type){
            case 'create': // 创建角色
                visible.value = true
                operate_type.value = 'create'
                modal_title.value = t('role.createRole')    
                for(let key in formData){
                    formData[key] = ''
                }
                formData.role_issued = false
                tenant_disabled.value = false
                if(userInfo.value.tenant_id !== 1){
                    getRoleParentTree()
                }
                break;
            case 'delete': // 删除角色
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('role.deleteTip'),
                    okText: t('base.ok'),
                    cancelText: t('base.cancel'),
                    onOk:()=>{
                        deleteRole(row)
                    },
                });
                break;
            case 'edit': // 编辑角色
                visible.value = true
                operate_type.value = 'edit'
                modal_title.value = t('role.editRole')
                rowData.value = row
                formData.role_name = row.role_name == '-' ? '' : row.role_name
                formData.role_desc = row.role_desc == '-' ? '' : row.role_desc
                formData.tenant_id = row.tenant_id
                formData.role_parent = row.role_parent
                formData.role_issued = row.role_issued == 0
                tenant_disabled.value = true
                getRoleParentTree(row)
                break;
            case 'bindMenu': // 角色关联菜单
                bindMenuVisible.value = true
                activeKey.value = '0'
                modal_title.value = t('role.bindMenu')
                rowData.value = row
                expandedKeys.value = []
                selectedKeys.value = []
                checkedKeys.value = []
                interfaceCheckedKeys.value = []
                getMenuTree()
                getInterfaceTree()
                break;
        }
    }

        
    const changeInput = ()=>{}

    const handleSearchByURLMethod = ()=>{
        getInterfaceTree()
    }

    // 分页
    const handleChangePagination =  (config, data)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getRoleList()
    }

    const handleChangeTenant = (value)=>{
        getRoleParentTree()
    }

    // 获取角色列表
    const getRoleList = async ()=>{
        let param = {
            display: category.value.length > 0? null : 0, // 是否显示：0：显示，1：不显示 ，不传查全部
            sys_org: searchForm.tenant_id,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await RoleApi.getInstance().getRoleList(param,page_num, page_size)
        if(res.code === 0){
            table.value.configs.loading = false
            let name_arr = ['sys:default', 'sys:admin', 'sys:test']
            let name_arr2 = ['sys:tenantDefault']
            let name_obj = {
                // 'sys:default': t('role.default'),
                // 'sys:admin': t('role.admin'),
                // 'sys:test': t('role.test'),
                'sys:tenantDefault': t('role.tenantDefault'),
            }
            table.value.data = []
            res.data.records.forEach(i=>{
                if(userInfo.value.tenant_id == 1){
                    table.value.data.push({
                        ...i,
                        role_name_text: i.role_name == undefined ? '-' : name_arr2.includes(i.role_name)? name_obj[i.role_name] : t(i.role_name),
                        role_name: i.role_name,
                        role_desc: !i.role_desc? '-' : i.role_desc,
                        role_parent: i.role_parent == undefined? '-' : i.role_parent,
                        tenant_name: i.tenant_name == undefined? '-' : i.tenant_name,
                        role_issued_text: i.role_issued === undefined? '-' : i.role_issued === 0 ? t('base.allow') : t('base.notAllow'),
                        category_text: i.category == undefined ? '-' : i.category === 1 ? t('role.selfCreated') : t('role.systemDefault'),
                    }) 
                }else if(userInfo.value.tenant_id != 1 && !name_arr.includes(i.role_name)){
                    table.value.data.push({
                        ...i,
                        role_name_text: i.role_name == undefined ? '-' : i.role_name == 'sys:tenantDefault' ? t('role.tenantDefault') : t(i.role_name),
                        role_name: i.role_name,
                        role_desc: !i.role_desc? '-' : i.role_desc,
                        tenant_name: i.tenant_name == undefined? '-' : i.tenant_name,
                        role_issued_text: i.role_issued === undefined? '-' : i.role_issued === 0 ? t('base.allow') : t('base.notAllow'),
                        category_text: i.category == undefined ? '-' : i.category === 1 ? t('role.selfCreated') : t('role.systemDefault'),
                    }) 
                }
            })
            table.value.configs.pagination.total = res.data.total
        }else{
            message.error(res.msg || res.message)
        }
    }

    const vaild = ()=>{
        if(!formData.role_name){
            message.error(t('role.roleName') +' '+ t('base.noEmpty'))
            return false
        }else if(userInfo.value.tenant_id == 1 && formData.tenant_id === ''){
            message.error(t('role.tenant') +' '+ t('base.noEmpty'))
            return false
        }else if(!formData.role_parent){
            message.error(t('role.roleParent') +' '+ t('base.noEmpty'))
            return false
        }

        return true
    }

    // 创建/编辑 角色
    const addRole = async()=>{
        if(!vaild()) return

        let param = {
            ...formData,
            sys_org: formData.tenant_id,
            role_issued: formData.role_issued? 0 : 1,
            category: 1,
            // tenant_id: userInfo.value.tenant_id,  // 0:创建   1：添加
        }
        if(operate_type.value == 'edit') param.display = 0
        let res = operate_type.value == 'create' 
                ? await RoleApi.getInstance().addRole(param) 
                : await RoleApi.getInstance().editRole(param, rowData.value.id)

        if(res.code === 0){
            visible.value = false
            table.value.configs.pagination.current = 1
            getRoleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 删除角色
    const deleteRole = async(row)=>{
        let res = await RoleApi.getInstance().deleteRole(row.id)
        if(res.code === 0){
            table.value.configs.pagination.current = 1
            getRoleList()
        }else{
            Modal.error({
                title: t('base.tip'),
                content: res.msg,
                okText: t('base.ok'),
                cancelText: t('base.cancel'),
                onOk:()=>{},
            })
        }
    }

    const handleChangeTab = (key)=>{
        activeKey.value = key
    }

    const handleCheckAll = (checked)=>{
        // console.log(checkedAll.value, 'checked')
        if(checkedAll.value){
            interfaceCheckedKeys.value = interfaceTreeData.value.map(i=>i.key)
            interface_menu_ids.value = interfaceCheckedKeys.value
        }else{
            interfaceCheckedKeys.value = []
            interface_menu_ids.value = []
        }
        // console.log(interfaceCheckedKeys.value, 'interfaceCheckedKeys')
    }

    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        getRoleList()
    }

    // 获取菜单树形结构数据
    const getMenuTree = async()=>{
        let param = {
            role_ids: [rowData.value.id],
            menu_types: [0, 1, 2],
            permission_flag: false,
        }
        let res = await MenuApi.getInstance().getMenuTree(param, userInfo.value.id)
        if(res.code === 0){
            // 组装树形数据结构
            function mapTreeData(data) {
                if(rowData.value.tenant_id !== 1){
                    return data.filter(item => item.tenant_display === 0).map(item => ({
                        bind_flag: item.menu_name == 'menu.Home'? true : item.bind_flag,
                        disabled: item.menu_name == 'menu.Home',
                        key: item.id,
                        title: t(item.menu_name),
                        menu_type: item.menu_type,
                        children: item.children && item.children.length > 0 ? mapTreeData(item.children) : undefined,
                    }))
                }else{
                    return data.map(item => ({
                        bind_flag: item.menu_name == 'menu.Home'? true : item.bind_flag,
                        disabled: item.menu_name == 'menu.Home',
                        key: item.id,
                        title: t(item.menu_name),
                        menu_type: item.menu_type,
                        children: item.children && item.children.length > 0 ? mapTreeData(item.children) : undefined,
                    }))
                }
                
            }

            // 获取已勾选的功能节点
            function getCheckedData(data) {
                return data.filter(item => item.bind_flag).map(item =>{
                    if(!item.children){
                        return item.key
                    }else{
                        return getCheckedData(item.children)
                    }
                })
            }

            // 获取已选择的菜单节点
            function getExpandedData(data) {
                let result = [];
                function recurse(items) {
                    items.filter(i=> i.bind_flag).forEach(item => {
                        if (item.menu_type === 0) {
                            result.push(item.key);
                        }
                        if (item.children && item.children.length > 0) {
                            recurse(item.children);
                        }
                    });
                }
                recurse(data);
                return result;
            }
            
            // 递归打平成一维数组
            function flatten(arr) {
                return arr.reduce((acc, val) => Array.isArray(val) ? acc.concat(flatten(val)) : acc.concat(val), []);
            }

            treeData.value = mapTreeData(res.data)
            expandedKeys.value = getExpandedData(treeData.value)
            checkedKeys.value = flatten(getCheckedData(treeData.value))

            console.log(treeData.value, 'treeData.value')
            // console.log(expandedKeys.value, 'getExpandedData')
            // console.log(checkedKeys.value, 'checkedKeys')

            if(expandedKeys.value.length > 0 || checkedKeys.value.length > 0){
                menu_ids.value = Array.from(new Set(checkedKeys.value.concat(expandedKeys.value)))
                console.log(menu_ids.value, 'menu_ids 99999')
            }
        }else{
            message.error(res.msg || res.message)
        }
    }   

    const handleMenuTreeCheck = (checkedKeys, info) => {
        // console.log('checkedKeys', checkedKeys, checkedKeys.value);
        // console.log('info', info);
        // console.log(checkedKeys.value, 'checkedKeys 11111')

        menu_ids.value = checkedKeys.concat(info.halfCheckedKeys)
        console.log(menu_ids.value, 'menu_ids')
        
        // console.log(expandedKeys.value, 'expandedKeys')
        // console.log(selectedKeys.value, 'selectedKeys')
        // console.log(checkedKeys.value, 'checkedKeys')
    }

    // 获取接口树形结构数据
    const getInterfaceTree = async()=>{
        let param = {
            role_ids: [rowData.value.id],
            menu_types: [3],
            permission_flag: false,
            menu_url: menu_url.value,
            menu_method: menu_method.value,
            menu_name: menu_name.value,
        }
        let res = await MenuApi.getInstance().getMenuTree(param, userInfo.value.id)
        if(res.code === 0){
            function mapTreeData(data) {
                return data.map(item => ({
                    key: item.id,
                    title: t(`${item.menu_name}:  ${item.menu_url},  ${item.menu_method}`),
                    children: item.children && item.children.length > 0 ? mapTreeData(item.children) : undefined,
                }));
            }
            interfaceTreeData.value = mapTreeData(res.data)
            interfaceCheckedKeys.value = res.data.filter(i=> i.bind_flag).map(i=> i.id)
            checkedAll.value = interfaceCheckedKeys.value.length === res.data.length

            if(interfaceCheckedKeys.value.length > 0){
                interface_menu_ids.value = interfaceCheckedKeys.value
            }
            // console.log(interface_menu_ids.value, 'interface_menu_ids  111111')
            // console.log(interfaceTreeData.value, 'interfaceTreeData')
        }else{
            message.error(res.msg || res.message)
        }
    }   

    const handleInterfaceTreeCheck = (checkedKeys, info) => {
        // console.log('checkedKeys', checkedKeys, checkedKeys.value);
        // console.log('info', info);

        interface_menu_ids.value = checkedKeys
        // console.log(interface_menu_ids.value, 'interface_menu_ids  222222')
    };

    // 角色关联菜单
    const addRoleMenu = async()=>{
        let param = [
            {
                id: rowData.value.id,
                menu_ids: menu_ids.value.concat(interface_menu_ids.value),
            }
        ]
        let res = await RoleApi.getInstance().addRoleMenu(param)
        if(res.code === 0){
            message.success(t('role.bindMenuSuccess'))
            bindMenuVisible.value = false
            getRoleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

      
    // 获取租户列表
    const getTenantList = async()=>{    
        let param = {
            limit_size: 100,
        }
        let res = await RoleApi.getInstance().getTenantList2(param)
        if(res.code === 0){
            tenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))

            searchTenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            searchTenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: null,
            })
        }else{
            message.error(res.msg || res.message)  
        }
    }

    // 获取角色父级树状列表
    const getRoleParentTree = async(row)=>{
        let tenant_id = row ? row.tenant_id : userInfo.value.tenant_id
        let param = {
            tenant_id: userInfo.value.tenant_id == 1 ? formData.tenant_id : tenant_id,
        }
        let res = await RoleApi.getInstance().getRoleParentTree(param, userInfo.value.id)
        if(res.code === 0){
            function getTreeData(data) {
                return data.map(item => ({
                    label: item.role_name,
                    value: item.id,
                    children: item.role_children && item.role_children.length > 0 ? getTreeData(item.role_children) : undefined,
                }))
            }
            selectTreeData.value = getTreeData(res.data)
            // console.log(selectTreeData.value, 'selectTreeData')
        }else{
            message.error(res.msg || res.message)
        }
    }

    const handleChangeRoleParent = (value) => {
        // console.log(value, 'value')
    }

    // 获取登录人账号类别
    const getTenantRoleList = async()=>{
        let param = {
            tenant_id: userInfo.value.tenant_id,
        }
        let res = await RoleApi.getInstance().getTenantRoleList(param, userInfo.value.id)
        if(res.code === 0){
            category.value = res.data.filter(i=> i.category === -1)
            console.log(category.value, 'category')
        }else{
            message.error(res.msg || res.message)
        }
    }


    // watch(expandedKeys, () => {
    //     console.log('expandedKeys', expandedKeys);
    // })
    // watch(selectedKeys, () => {
    //     console.log('selectedKeys', selectedKeys);
    // })
    // watch(checkedKeys, () => {
    //     console.log('checkedKeys', checkedKeys);
    // })


    onMounted(async ()=>{
        await getTenantRoleList()
        getRoleList()
        getTenantList()
    })
</script>

<style lang="scss" scoped>
.operate_btn{
    margin-top: 30px;
}

.query_box{
    margin-top: 30px;
    margin-bottom: 20px;

    .query_field{
        display: inline-block;
        margin-right: 10px;
        width: 200px;
    }
}

.form{
    .form_item{
        margin-bottom: 15px;

        .form_item_label{
            font-size: 16px;
            font-weight: 600;
        }

        .required{
            color: red;
        }
    }
}

.modal_title{
    margin-bottom: 20px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
}

::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

// 子表格的表体行样式
::v-deep .subTableBg{
    background: #f6f6f6 !important;
}


::v-deep .ant-tree-list{
    max-height: 600px !important;
    overflow-y: scroll;
}
</style>